import { useEffect } from "react";
import Checkbox from "components/Checkbox";
import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { uploadFileStore } from "./UploadFileStore";
import { buildingStore } from "store/Building/BuildingStore";
import { BuildingCalculationEngine } from "api-client";

export default observer(function SplitQuantityCheckbox() {
  const { t } = useTranslation();

  // The MATRICES calculation mode does not support importing the quantity, so
  // objects must always be created from the quantity. Force the option on and
  // lock it in that case (matches the backend validation).
  const isMatricesMode =
    buildingStore.currentBuilding?.calculation_mode ===
    BuildingCalculationEngine.Matrices;

  useEffect(() => {
    if (isMatricesMode) {
      uploadFileStore.setSplitQuantityIntoObjects(true);
    }
  }, [isMatricesMode]);

  const checkbox = (
    <Checkbox
      id="splitQuantityIntoObjects"
      checked={uploadFileStore.splitQuantityIntoObjects}
      disabled={isMatricesMode}
      labelElement={t("buildingMaterialResources.splitQuantityIntoObjects")}
      onChange={(e) =>
        uploadFileStore.setSplitQuantityIntoObjects(e.currentTarget.checked)
      }
    />
  );

  if (!isMatricesMode) return checkbox;

  return (
    <Tooltip
      content={t(
        "buildingMaterialResources.splitQuantityIntoObjectsLockedTooltip"
      )}
      noFlex
      noIcon
      disableStickOnHover
    >
      {checkbox}
    </Tooltip>
  );
});
